import React, { useState } from "react";

const DetailsTabs = ({ breakingChanges, releaseNotes }) => {
  return (
    <div className="">
      <div className="upgrade_item_contant upgrade_one">
        <div className="upgrade_item_heading">
          Minimum Recommended Requirements
        </div>
        <div className="upgrade_item_body">
          <div className="pre_core">
            <div className="pre_core_head">
              Minimum Recommended Requirements
            </div>
            <ul className="simple shift-left">
              <li>
                <dl className="first docutils">
                  <dt>Processor: 4 Core CPU (3.6Ghz)</dt>
                </dl>
              </li>
              <li>
                <dl className="first docutils">
                  <dt>Free Hard Disk Space: 1 GB</dt>
                  <dd>
                    <ul className="first last shift-left">
                      <li>
                        SSD drives are recommended for optimal database
                        performance
                      </li>
                    </ul>
                  </dd>
                </dl>
              </li>
              <li>
                <dl className="first docutils">
                  <dt>RAM: 16 GB</dt>
                </dl>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div className="upgrade_item_contant upgrade_two">
        <div className="upgrade_item_heading">Breaking Changes</div>
        <div className="upgrade_item_body breaking_changes">
          {breakingChanges ? (
            <div dangerouslySetInnerHTML={{ __html: breakingChanges }} />
          ) : (
            "There are no known breaking changes between these versions. Report any issues to customersupport@izenda.com"
          )}
        </div>
      </div>

      <div className="upgrade_item_contant upgrade_three">
        <div className="upgrade_item_heading">Release Notes</div>
        <div className="upgrade_item_body breaking_changes">
          {releaseNotes ? (
            <div
              dangerouslySetInnerHTML={{
                __html: releaseNotes.replace("¶", "")
              }}
            />
          ) : (
            "There are no known release notes between these versions. Report any issues to customersupport@izenda.com"
          )}
        </div>
      </div>
      {/* <div className="troubleShootText">
        Troubleshooting?{" "}
        <span className="dwn-ut_txt" onClick={e => diagnosticPopup(true)}>
          Download our Diagnostic Utility
        </span>
      </div> */}
    </div>
  );
};

export default DetailsTabs;



// WEBPACK FOOTER //
// ./src/components/Profile/UpgradeComponent/DetailsTabs.js